import { i18nResponseDto } from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';

export function getAttributes(
  language: LanguagesType,
  attributes: i18nResponseDto[] | undefined,
): { attributes: i18nResponseDto[] } | undefined {
  if (!attributes?.length) return undefined;

  const attributesToCreate: i18nResponseDto[] = attributes.map((attribute) => ({
    ...attribute,
    default: attribute[language],
  }));
  return { attributes: attributesToCreate };
}

export function getI18nResponseDto(
  dto: i18nResponseDto,
  language: LanguagesType,
): i18nResponseDto {
  if (!dto) return { default: '' };
  return {
    ...(dto.en ? { en: dto.en } : {}),
    ...(dto.es ? { es: dto.es } : {}),
    ...(dto.pt ? { pt: dto.pt } : {}),
    default: dto[language] ?? '',
  };
}
